// FUNNEL VUEX ACTIONS
import {makePostRequest} from '@/js/global/helpers/requests';
export default {

   /**
    * Get a specific cart by it's number (not shortNumber).
    *
    * @param commit
    * @param cartNumber {string}
    * @return {Promise<*|{data: {cart: null}}>}
    */
   async getCartByNumber({commit}, cartNumber) {
      if (typeof cartNumber === 'string' && cartNumber) {
         let urlParams = new URLSearchParams(window.location.search);
         const params = {};
         for(const [key, value] of urlParams.entries()) {
            params[key] = value;
         }

         return await makePostRequest('mymy/funnel/get-cart-by-number', {
            number: cartNumber,
            scenario: window.mymy.request.scenario,
            params: params,
         });
      }

      return {data: {cart: null, success: false}};
   },

   /**
    * Get a new cart number when the customer has submitted their selected menu items and wants to
    * go to checkout.
    *
    * @param commit
    * @return {Promise<*|{success: boolean, number: string}>}
    */
   async getNewCartNumber({commit}) {
      return await makePostRequest('mymy/funnel/get-new-cart-number', {
         site: window.mymy.request.currentSite.id,
         menuProductId: window.mymy.menu.id,
      });
   },

   /**
    * Post to Commerce's `CartController::actionUpdateCart` method to update the customer's cart.
    *
    * @param state {Object}
    * @param data {Object}
    * @return {Promise<AxiosResponse<any>>}
    */
   updateCart({state}, data) {

      // always provide this data
      data['scenario'] = window.mymy.request.scenario;
      data['number'] = state.cart.number ?? window.mymy.cart.number ?? null;

      if (! data['fields']) {
         data['fields'] = {};
      }

      data.orderSiteId = window.mymy.request.currentSite.id;
      data.fields.relatedSite = window.mymy.request.currentSite.handle;

      return makePostRequest('commerce/cart/update-cart', data);
   },

   /**
    * Post to Commerce's `PaymentsController::actionPay()` method to start a payment transaction
    * by the customer, effectively checking out.
    *
    * @param state {object}
    * @param data {object}
    * @return {Promise<AxiosResponse<any>>}
    */
   makePayment({state}, data) {

      // always provide this data
      data['scenario'] = window.mymy.request.scenario;
      data['number'] = state.cart.number ?? window.mymy.cart.number ?? null;

      return makePostRequest('commerce/payments/pay', data);
   },

   /**
    * Handle the results coming back from the Availability Check that the customer just triggered.
    *
    * @param commit
    * @param state
    * @param results
    */
   handleAvailabilityCheckResults({commit, state}, results) {
      // add the results to the `checks` array regardless of availability verdict
      commit('addAvailabilityCheckResult', results);

      if (! results.isAvailable) {
         return;
      }

      // if there is availability for the customer's criteria, designate the menu they clicked
      // on as the "selected" menu
      const menu = state.menus[results.menu.slug] ?? null;
      if (! menu) {
         return;
      }
      commit('setSelectedMenu', menu);
   },

   /**
    * Post to Commerce's `CartController::actionUpdateCart()` method to update the customer's cart.
    *
    * @param context {Object}
    * @param availabilityCheckModel {Object}
    * @return {Promise<AxiosResponse<any>>}
    */
   async updateCartWithAvailabilityCheck({commit, getters, state}, availabilityCheckModel) {

      const response = await makePostRequest(
         'mymy/funnel/update-cart-with-availability-check' + window.location.search,
         {
            number: state.cart.number ?? null,
            acData: availabilityCheckModel,
         }
      );

      // since this call could create a new cart for the customer, we need to update the cart's data
      // to match anything that's changed
      if (response.data.success && response.data.cart) {
         commit('updateCartData', response.data.cart);
      }

      return response;
   },
}